export const PROTOCOL_HTTP = "http";
export const HOST_API =
  process.env.REACT_APP_API_URL || "https://api.almacensandra.com.co/";
// export const HOST_API = "http://localhost:3030/";
export const PATH_S3_BUCKET = "https://casandra-static.s3.amazonaws.com";
export const DEFAULT_AVATAR_IMAGE = "../../../public/avatar.png";

export const BUCKET = "casandra-static";
